import jwtAuthAxios from "./auth/jwtAuth";

const authServices = {};

authServices.getCurrentUser = async () => {
    try{
        const response = await jwtAuthAxios.post("/api/user/userdata/");
        return response.data
    } catch (e) {
        return {
            hasError: true,
            error: "Some error received from the api",
        };
    }
};

//loginCreds must be {email: "abc@example.com", password: "ABC123DEF"}
authServices.signIn = async (loginCreds) => {
    try {
        return await jwtAuthAxios.post('/api/authenticate/', loginCreds);
    } catch (e) {
        return e.response;
    }

};



//login based on access token
authServices.manualSignIn = async (accesstoken) => {
    try {
        return await jwtAuthAxios.post('/api/manualsignin/', accesstoken);
    } catch (e) {
        return e.response;
    }

};

export default authServices;